import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { useOptionalDescriptionColumn } from 'components/CIMSTable/common/hooks/useDescriptionColumn'
import { useNameColumn } from 'components/CIMSTable/common/hooks/useNameColumn'
import { HelpMessage } from 'utils/constants'
import { RFIOrganization } from '../../../OrganizationsTableContext'

export const useColumns = (): CIMSColumn<RFIOrganization>[] => {
  return [
    useNameColumn({
      help: HelpMessage.RequestsForInformation.Organizations.Name,
      sort: { default: 'ascend' },
    }),
    useOptionalDescriptionColumn('Organization'),
  ]
}
